import { login, getQywxPeriods } from "@/api/home";
import { getToken, setToken, removeToken } from "@/utils/auth";
import Message from "element-plus";
export const user = {
  namespaced: true,
  state: {
    token: "",
    periods: [], //账期列表
    currentUserId: "",
  },
  mutations: {
    setPeriods(state, periods) {
      state.periods = periods;
    },
    SET_USERID: (state, data) => {
      state.currentUserId = data
    },
  },
  actions: {
    Login({ commit }, userInfo) {
      const chatId = userInfo;
      login({ chatId: chatId }).then((res) => {
        if (res.data.msg == "success") {
          setToken(res.data.token);
        } else {
          Message({
            message: res.data.msg,
            type: res.data.msg,
          });
        }
      });
    },
    InitPeriod({ commit }, e) {
      return new Promise((resolve, reject) => {
        let periods = [];
        getQywxPeriods({ comId: e })
          .then((res) => {
            periods = res.data.data;
            commit("setPeriods", periods);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setParam({ commit }, data) {
      commit('SET_USERID', data)
    },
  },
  getters: {
    periods(state) {
      return state.periods;
    },
    params(state) {
      return state.currentUserId
    },
  },
};
